import bdjs from "@bd-core/bdjs";
import $ from "jquery";
import { mark } from "@bd-core/firebase-actions";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import { formatTime } from "../utils/formatTime";

export const HomePage = () => {
    const isHomePage = $("#home-page").length > 0;
    if (!isHomePage) return false;

    let startTime = null;
    let accumulatedTime = 0;
    let isPaused = false;
    let isFinished = false;
    let selfMark = 0;
    let teamMark = 0;
    let isFullyFinished = false;
    const maxSceneDuration = 2 * 60 * 60;

    const setSessionInitialState = (e, eData) => {
        const data = eData?.data?.data || eData?.data;
        bdjs.hideLoading();

        if (!data) return;

        startTime = data.startTime;
        accumulatedTime = typeof data.accumulatedTime === 'number' && !isNaN(data.accumulatedTime) 
            ? data.accumulatedTime 
            : 0;
        isPaused = data.isPaused;
        isFinished = data.isFinished;
        isFullyFinished = data.isFullyFinished;

        if (data.marks) {
            selfMark = data.marks[CONFIG.user_id]?.self || 0;
            teamMark = data.marks[CONFIG.user_id]?.team || 0;
        }

        if (data.marks && data.marks[CONFIG.user_id]) {
            const userMarks = data.marks[CONFIG.user_id];
            if (userMarks.self) {
                $(".option--player").addClass("is-finished");
                $(".option--player .finished-title").text(
                    `Marked at ${formatTime(userMarks.self)}`,
                );
            }
            if (userMarks.team) {
                $(".option--team").addClass("is-finished");
                $(".option--team .finished-title").text(
                    `Marked at ${formatTime(userMarks.team)}`,
                );
            }
        }

        const timerElement = $(".home__time__text");
        if (isPaused || isFinished || !startTime) {
            timerElement.text(formatTime(accumulatedTime));
        } else {
            const elapsedTime = accumulatedTime + (Date.now() - startTime) / 1000;
            const displayTime = Math.min(elapsedTime, maxSceneDuration);
            timerElement.text(formatTime(displayTime));
        }
    };

    const setSessionDataChanged = (e, eData) => {
        const data = eData?.data?.data || eData?.data;

        if (!data) return;

        startTime = data.startTime;
        accumulatedTime = typeof data.accumulatedTime === 'number' && !isNaN(data.accumulatedTime) 
            ? data.accumulatedTime 
            : 0;
        isPaused = data.isPaused;
        isFinished = data.isFinished;
        isFullyFinished = data.isFullyFinished;

        if (data.marks) {
            selfMark = data.marks[CONFIG.user_id]?.self || 0;
            teamMark = data.marks[CONFIG.user_id]?.team || 0;
        }

        if (isFullyFinished) {
            window.location.href = "/";
        }

        const timerElement = $(".home__time__text");
        if (isPaused || isFinished || !startTime) {
            timerElement.text(formatTime(accumulatedTime));
        } else {
            const elapsedTime = accumulatedTime + (Date.now() - startTime) / 1000;
            const displayTime = Math.min(elapsedTime, maxSceneDuration);
            timerElement.text(formatTime(displayTime));
        }
    };

    bdjs.listen("bd__sessionInitialState", setSessionInitialState);
    bdjs.listen("bd__sessionDataChanged", setSessionDataChanged);

    const updateTimer = () => {
        const timerElement = $(".home__time__text");
        const elapsedTime = accumulatedTime + (Date.now() - startTime) / 1000;
        const displayTime = Math.min(elapsedTime, maxSceneDuration);

        timerElement.text(formatTime(displayTime));
    };

    setInterval(() => {
        if (isFinished || isPaused || !startTime) return;

        updateTimer();
    }, 1000);

    const $page = $(".home");
    const $option = $(".js-option");
    const $tutorialBtn = $(".js-open-tutorial");
    const $tutorialCloseBtn = $(".js-close-tutorial");

    const HOLD_DURATION = 800;
    const UPDATE_INTERVAL = 16;

    const triggerHaptic = (type = "light") => {
        if (!navigator.vibrate) return;
        
        const patterns = {
            light: [10],
            medium: [20],
            heavy: [30],
            success: [10, 50, 10],
            error: [50, 100, 50]
        };
        
        navigator.vibrate(patterns[type] || patterns.light);
    };

    $option.on("mousedown touchstart", function (e) {
        const $this = $(this);

        if (e.type === 'touchstart') {
            e.preventDefault();
        }

        if (!startTime || isFinished || isPaused) {
            return;
        }

        const $progress = $this.find(".option__progress");
        let progress = 0;
        const isUnmarking = $this.hasClass("is-finished");
        const markAttr = $this.data("mark");
        const currentMark = markAttr === "self" ? selfMark : teamMark;

        if (isUnmarking && !currentMark) {
            return;
        }

        triggerHaptic("light");

        $this.addClass("is-holding");
        $progress.css("width", "0%");

        const progressTimer = setInterval(async () => {
            progress += (UPDATE_INTERVAL / HOLD_DURATION) * 100;
            if (progress >= 100) {
                progress = 100;
                $progress.css("width", "100%");
                clearInterval(progressTimer);
                $this.removeData('progressTimer');
                
                triggerHaptic("success");
                
                if (isUnmarking) {
                    $this.removeClass("is-finished");
                    $this.find(".finished-title").text("");

                    let data = {
                        [markAttr]: null,
                    };

                    mark(data);
                    await bdjs.goAsync(
                        bdapi.post("game/set-player-mark", {
                            mark: markAttr,
                            accumulated_time: 0,
                        }),
                    );
                } else {
                    $this.addClass("is-finished");

                    const elapsedTime =
                        accumulatedTime + (Date.now() - startTime) / 1000;
                    let data = {
                        [markAttr]: elapsedTime,
                    };

                    $this
                        .find(".finished-title")
                        .text(`Marked at ${formatTime(elapsedTime)}`);

                    mark(data);
                    await bdjs.goAsync(
                        bdapi.post("game/set-player-mark", {
                            mark: markAttr,
                            accumulated_time: elapsedTime,
                        }),
                    );
                }
            } else {
                $progress.css("width", `${progress}%`);
            }
        }, UPDATE_INTERVAL);

        $this.data('progressTimer', progressTimer);
    });

    $option.on("mouseup mouseleave touchend touchcancel", function () {
        const $this = $(this);

        const $progress = $this.find(".option__progress");

        $this.removeClass("is-holding");
        
        const progressTimer = $this.data('progressTimer');
        
        if (progressTimer) {
            clearInterval(progressTimer);
            $this.removeData('progressTimer');
            triggerHaptic("light");
        }
        
        $progress.css("width", "0%");
    });

    let isInteracting = false;
    
    $option.on("touchstart", function() {
        isInteracting = true;
    });
    
    $option.on("touchend touchcancel", function() {
        isInteracting = false;
    });
    
    document.addEventListener('touchmove', function(e) {
        if (isInteracting) {
            e.preventDefault();
        }
    }, { passive: false });

    $tutorialBtn.on("click", function () {
        $page.addClass("is-tutorial-open");
    });

    $tutorialCloseBtn.on("click", function () {
        $page.removeClass("is-tutorial-open");
    });
};
